import axios from 'axios';
import retry from 'axios-retry';

// Add Authorization header on the request
const addAuthorizationHeader = config => {

  if (localStorage.authToken) {
    config.headers.Authorization = `Bearer ${localStorage.authToken}`;
  }

  return config;
};

const api = axios.create();
api.interceptors.request.use(addAuthorizationHeader);

retry(api, { retries: 3, retryCondition: error => {
  return !error.response || error.response.status === 401;
}});

export default api;



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/store/utils/request.js